module.exports = __webpack_public_path__ + "img/birds.c2eca120.png";